export default __webpack_public_path__ + "static/media/vector-doctor.b97d061e.svg";